import { Component, AfterViewInit } from "@angular/core";
import { Router } from "@angular/router";
import { KeycloakService } from "keycloak-angular";
import { KeycloakStateService } from "../core/service/utility.service";
import { MatDialog } from "@angular/material/dialog";
import { EnvironmentService } from "../core/service/environment.service";
import { WalkthroughService } from "../core/service/walkthrough.service";
import { UserManagementComponent } from "../features/user-management/user-management.component";
import { UserService } from "../features/user-management/users/user.service";

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"],
})
export class HomeComponent  {

  userHasAccess = false;
  isLoggedIn = false;
  disableVideoGuide = true;


  constructor(
    private router: Router,
    private keycloakService: KeycloakService,   
    private keycloakStateService: KeycloakStateService,
    private dialog: MatDialog,
    public environmentService: EnvironmentService,
    private walkthroughService: WalkthroughService,
     private userService: UserService,
  ) {}

async ngOnInit() {
  this.isLoggedIn = await this.keycloakService.isLoggedIn();

  if (this.isLoggedIn) {
    const token = await this.keycloakService.getToken();
    const decoded: any = JSON.parse(atob(token.split('.')[1]));

  }

    this.keycloakStateService.observeRealmRoles().subscribe(roles => {
    this.userHasAccess = roles.some(role => role.toLowerCase() === 'ztaas_admin');
  });

      if (this.isLoggedIn && !localStorage.getItem('firstLoginTour')) {
    setTimeout(() => this.walkthroughService.startTour(), 800);
    localStorage.setItem('firstLoginTour', 'true');
  }
  
}



  gotToDigitalIdManagement() {
    this.router.navigate(["/digital-identity/auth-tools"]);
  }
  gotToAdaptiveAccessControl() {
    this.router.navigate(["/ada-access/auth-tools"]);
  }
  gotToAssetManagement() {
    this.router.navigate(["/asset-management/auth-tools"]);
  }
  gotToDataProtectionManagement() {
    this.router.navigate(["/data-protection/auth-tools"]);
  }

  gotToSecureBlockchain() {
    this.router.navigate(["/secure-blockchain/auth-tools"]);
  }

  gotToDSOGuard() {
    this.router.navigate(["/dso-guard/auth-tools"]);
  }

  gotToInsightEgrc() {
    this.router.navigate(["/insight-egrc/auth-tools/risk-management/risk-register-search"]);
  }

  gotToSecureZone() {
    this.router.navigate(["/secure-zone"]);
  }



  goToVideoGuides() {
    this.router.navigate(['/guide']);
  }

  
 async logout(): Promise<void> {

    try {

      // Refresh token before logout
      try {
        await this.keycloakService.updateToken(30);
      } catch (refreshError) {
        console.warn(
          'Token refresh failed before logout',
          refreshError
        );
      }

      const kc =
        this.keycloakService.getKeycloakInstance();

      // Prevent invalid id_token_hint=undefined
      if (!kc.idToken) {

        console.warn(
          'No idToken available. Redirecting manually.'
        );

        window.location.href = window.location.origin;

        return;
      }

      await this.keycloakService.logout(
        window.location.origin
      );

    } catch (error) {

      console.error('Logout failed', error);

      window.location.href = window.location.origin;
    }
  }

  openUserManagement() {
    if (this.userHasAccess) {
      this.dialog.open(UserManagementComponent, { width: '1000px', height: '700px' });
    } else {
      alert('Unauthorized');
    }
  }
  
// openUserManagement(): void {

//   if (!this.userHasAccess) {

//     alert('Unauthorized');

//     return;
//   }

//   const organizationId =
//     this.keycloakStateService.getOrganizationId();

//   this.userService
//     .getUsers(0, organizationId)
//     .subscribe({

//       next: (users) => {

//         this.dialog.open(
//           UserManagementComponent,
//           {
//             width: '1000px',
//             height: '700px',
//             data: {
//               initialUsers: users
//             }
//           }
//         );
//       },

//       error: (error) => {

//         console.error(
//           'Failed to load users',
//           error
//         );

//         // Interceptor will navigate to error page
//         // Dialog never opens
//       }
//     });
// }
}
